import { ReactComponent as Pencil } from 'assett/icons/pencil.svg';
import { ReactComponent as UploadCompleted } from 'assett/icons/upload_completed.svg';
import { FC, useState } from 'react';
import { IconButton, Stack } from 'styles';
import { IFileType } from 'types/Claim';
import { DocType } from 'types/Upload';
import DeletePopup from './DeletePopup';
import FileNameEditor from './FileNameEditor';

type AttachmentProps = {
	data?: IFileType;
	documentType: DocType;
};

const ManyAttachmentRow: FC<AttachmentProps> = ({ data, documentType }) => {
	const [isEditMode, setIsEditMode] = useState(false);

	const enableEditModeAction = () => {
		setIsEditMode(true);
	};

	return (
		<>
			<Stack direction={'row'} justifyContent={'space-between'} gap={'8px'}>
				<Stack direction={'row'} gap={'15px'} width={'100%'}>
					<UploadCompleted width={'24px'} height={'24px'} />
					<FileNameEditor
						documentType={documentType}
						data={data}
						isEditMode={isEditMode}
						setIsEditMode={setIsEditMode}
					/>
				</Stack>
				<Stack direction={'row'} gap={'20px'}>
					<IconButton onClick={enableEditModeAction}>
						<Pencil width={'24px'} height={'24px'} />
					</IconButton>
					{data ? (
						<DeletePopup
							data={{ uuid: data.uuid, fileName: data.fileName || '' }}
							documentType={documentType}
						/>
					) : null}
				</Stack>
			</Stack>
		</>
	);
};

export default ManyAttachmentRow;
